export default __webpack_public_path__ + "static/step_6_en-465c1fef3482a54da32b8923945e944d.svg";